import { render, staticRenderFns } from "./GermanTable.vue?vue&type=template&id=577f9d9e&scoped=true&"
import script from "./GermanTable.vue?vue&type=script&lang=js&"
export * from "./GermanTable.vue?vue&type=script&lang=js&"
import style0 from "./GermanTable.vue?vue&type=style&index=0&id=577f9d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f9d9e",
  null
  
)

export default component.exports